import { ref } from 'vue';
import * as Sentry from '@sentry/vue';

export type ToastType = 'success' | 'error' | 'info';

interface ToastOptions {
  title?: string;
  type: ToastType;
  message: string;
  duration?: number;
}

interface Toast extends ToastOptions {
  id: number;
  duration: number;
}

const toasts = ref<Toast[]>([]);
let nextId = 0;

export function useToast() {
  const createToast = (options: ToastOptions) => {
    if (options.type === 'error') {
      Sentry.captureMessage(options.message, {
        level: 'error',
        tags: {
          source: 'toast',
        },
        extra: {
          title: options.title,
        },
      });
    }

    const id = nextId++;
    const toast: Toast = {
      id,
      title: options.title,
      type: options.type,
      message: options.message,
      duration: options.type === 'error' ? Infinity : options.duration ?? 2000
    };

    toasts.value.push(toast);
    
    if (toast.duration > 0 && toast.duration !== Infinity) {
      setTimeout(() => {
        removeToast(id);
      }, toast.duration);
    }
  };

  const removeToast = (id: number) => {
    const index = toasts.value.findIndex(t => t.id === id);
    if (index > -1) {
      toasts.value.splice(index, 1);
    }
  };

  return {
    toasts,
    createToast,
    removeToast
  };
}